var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.03 11.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3210e0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.54,0H1.5C.63,0,0,.62,0,1.49V10c0,.86,.63,1.49,1.49,1.49h7.05c.86,0,1.49-.64,1.49-1.49V1.49c0-.86-.63-1.49-1.49-1.49ZM2.29,3.18c.09-.07,.21-.13,.32-.13,.9-.01,4.44-.01,5.34-.01,.28,0,.5,.24,.49,.53,0,.28-.21,.51-.49,.52H2.61c-.21,0-.4-.15-.47-.34-.07-.21-.02-.44,.15-.57Zm-.15,2.33c.07-.22,.27-.36,.53-.36H7.91c.24,0,.41,.11,.5,.33,.08,.21,.04,.4-.11,.56-.12,.13-.27,.17-.45,.17H2.67c-.39-.01-.65-.34-.53-.7Zm5.78,2.81H2.66c-.38,0-.64-.35-.52-.69,.06-.19,.19-.31,.39-.35,.05-.01,.11-.02,.16-.02H7.86c.24,0,.43,.09,.54,.31,.16,.35-.09,.74-.48,.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.fc9e9cd1db5263a9885cc39f561ab1a0.svg";
export { ForwardRef as ReactComponent };